module.exports = __webpack_public_path__ + "static/img/add.9f0985d4.png";